jQuery(document).ready(function () {
    var $ = jQuery;

    var singleEventsClass = $('.event-form-wrapper');
    var singleEventID = singleEventsClass.attr('data-currentPost');
    var checkboxPost = $('.checkboxPost[data-eventid="' + singleEventID + '"]');
    checkboxPost.closest('li').find('[type=checkbox]').prop('checked', true);


    // $('.event-label-inner').on('change', function () {
    //     console.log('change');
    //     // var label = jQuery(this).find('.event_title').text();
    //     var label = 'label';
    //     var textComment = jQuery(this).find('.comment-box').text();
    //     var eventLabelInner = jQuery(this);
    //     var sessionLists = eventLabelInner.children('.session-wrapper');
    //     var sessionChoices = '';
    //     sessionLists.each(function () {
    //         var sessionID = jQuery(this).find('.session-name').text();
    //         var sessionList = jQuery(this).find('.session-list');
    //         var chosenSession = sessionList.find('[type = radio]:checked')[0].value;
    //         sessionChoices += ' | ' + sessionID + ': ' + chosenSession;
    //     });
    //     console.log(sessionChoices);
    //     jQuery(this).closest('li').find('input').val(label + ': ' + textComment + sessionChoices);
    // });

    $('.gfield.events-posts').on('change', function () {
        var eventOptions = jQuery(this).find('.gfield_checkbox>li');
        // console.log(eventOptions);
        // loop thru each event and update values on changes
        var textCommentPresent = false;
        var textCommentStartString = ': Comments: ';
        eventOptions.each(function () {
            // console.log(jQuery(this).find('.event_title')[0].dataset.title);
            var eventTitle = jQuery(this).find('.event_title')[0].dataset.title;
            // console.log(eventTitle.data('eventTitle'));
            var textComment = jQuery(this).find('.comment-box')[0].value;
            textCommentPresent = true;
            var sessionLists = jQuery(this).find('.session-wrapper');
            var sessionChoices = ' | Session Choices: ';
            // console.log(sessionLists);
            sessionLists.each(function () {
                var sessionID = jQuery(this).find('.session-name').text();
                var sessionList = jQuery(this).find('.session-list');
                var chosenSession = sessionList.find('[type = radio]:checked')[0].value;
                sessionChoices += ' | ' + sessionID + ': ' + chosenSession;
            });
            var EventValue = eventTitle;
            if (textCommentPresent === true) {
                EventValue += textCommentStartString + textComment;
            }
            if (sessionLists.length >= 1) {
                EventValue += sessionChoices;
            }
            // console.log(EventValue);
            // console.log(jQuery(this).closest('input[type=checkbox]').prevObject['0'].firstElementChild.value);
            jQuery(this).closest('input[type=checkbox]').prevObject['0'].firstElementChild.value = EventValue;
            // jQuery(this).closest('input').value() = EventValue;
            // jQuery(this).closest('[type=checkbox]').val(EventValue);
            // jQuery(this).closest('li').find('[type=checkbox]')
        });
    });



    $('#gform_7 .session-wrapper').on('change', function () {
        // var choice = jQuery(this);
        // console.log(choice);
        // console.log(jQuery(this).find('.session-name').text());
        // var activeSession = choice.closest('.session-list').find('[type=radio]').prop('checked');
        // console.log(activeSession);
        // var label = jQuery(this).closest('label').find('.event_title').text();
        // console.log(jQuery(this).prev());
        // console.log($('input[name=radioName]:checked', '#gform_7'));
    });

    $('.address_country select').addClass('gfield_select');

    if ($('.gform_wrapper')) {
        $('<p><strong><sup>*</sup></strong>Required Field</p>').prependTo($('.gform_wrapper'));

    }
    // console.log($('.gform_wrapper'));
    // $("<p>Test</p>").prependTo(".gform_wrapper");
    $("#extensions_message_10_6").text('Accepted file types: .doc, .docx, .pdf.');
});